import { BrowserAuthError } from '@azure/msal-browser';

export function isBrowserAuthError(error: unknown): error is BrowserAuthError {
    if (error === null || typeof error !== 'object') {
        return false;
    }
    if ('name' in error) {
        return error.name === 'BrowserAuthError';
    }
    return false;
}

export function isUserCancelledError(error: unknown): boolean {
    if (isBrowserAuthError(error)) {
        return error.errorCode === 'user_cancelled';
    }
    return false;
}

export function isPopupsBlockedError(error: unknown): boolean {
    if (isBrowserAuthError(error)) {
        return error.errorCode === 'popup_window_error';
    }
    return false;
}
